export default __webpack_public_path__ + "static/media/icon10.afc3468e.svg";